// import { filterPrograms, filterSnapshotPrograms } from '../store/reselectors/filteredPrograms.reselector';
import { User } from '../../../globals/store/user.data';
import { FilterGroup, filterTypes, FilterGroupGroups, filterPageTypes, FilterGroupTypes, filterFilters } from '../../../globals/store/filters.data';
import { FiltersGroupingUI, FilterUIType, FilterUI, FiltersGroupUI } from '../../../globals/store/filters-ui.models';
import { computed, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
// import { first } from 'rxjs/operators';
// import { filterTasks } from '../store/reselectors/filteredTasks.reselector';
// import { unfilteredFullMultiTimelineReselector } from '../store/reselectors/onsiteTimeline.reselector';
// import { JoiEvent, WFWorker, LabelMaps, eventStateSelector } from '../store/events.era';
import { Account, AccountPublicInfo } from '../../../globals/store/accounts.data'
// import { Dictionary } from '@ngrx/entity';
import { Task, OMEGA_GROUP_ID, OMEGA_GROUP_NAME, filterTimeTasks } from 'globals/store/tasks.data';
import { AllSameKeysEnforcer, getProgramDayOrDateByFilterIdConstructor, nameJoiner } from '../helpers/helpers';
// import { Performer } from '../store/performers.data';
// import { filterTimeline } from '../store/reselectors/onsite.reselector.filtering';
// import { Program, DateSchedule } from '../store/programs.data';
// import { filterFilters } from '../store/filters.data';
// import { getOnsiteTimelineSets, filterOnsiteTimelineFilters } from '../share/onsite.filtering';
import { UiService } from 'src/app/services/ui.service';
// import { ProgramsPerformersSponsors, filterProgramsSessionsByPerformers, ProgramsSponsors, filterProgramsSessionsBySponsors } from '../store/reselectors/performerSponsors.reselector';
// import { Sponsor } from '../store/sponsors.data';
// import { filterExhibitors, Exhibitor, ProgramsExhibitors, filterExhibitorStands } from '../store/exhibitors.data';
// import { OnsiteActivity } from '../store/onsite.data';
// import { filterHomeEvents, frontPageFilterUIDataReselector } from '../store/reselectors/filteredEvents.reselector';
// import { getWorkersByEmailAndUidFromMultipleEvents } from '../store/workforce.data';
import { FLAGGED_ASSETS, FLAGGED_TASKS, MY_CREATED_ASSETS, MY_CREATED_TASKS, MY_EVENTS, MY_RESPONSIBLE_ASSETS, MY_RESPONSIBLE_TASKS } from '../../../globals/helpers/constants';
// import { getStandIdsByExhibitorIds } from './../modules/program/program.helpers';
import { assetIconIds, assetIconToName } from 'globals/store/assets.data';
// import { FLAGGED_TASKS } from 'src/app/helpers/constants';
// import { filterAssets, programsByAssetIdsReselector } from '../store/reselectors/assets.reselector';
// import { filterResources, getResourcesWithQuotes, JoiResource } from './../store/resources.data';
// import { PROGRAM_NAMES, sortPidOrderArray, sortPrograms } from '../store/programs.data';
import { JoiEvent, Label, LabelMaps, Ranking } from '../../../globals/store/events.data';
import { DateSchedule, Program, PROGRAM_NAMES, sortPidOrderArray, sortPrograms } from 'globals/store/programs.data';
import { getWorkersByEmailAndUidFromMultipleEvents, WFWorker } from 'globals/store/workforce.data';
import { flatten, getNestedSet, getSet, makeMapFromListOfObjectsAndKey, setIntersection, sortByProp } from 'globals/helpers/helpers';
import { Performer } from 'globals/store/performers.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { userStateSelector } from '../store/user.era';
import { filterActions, filterStateSelector } from '../store/filters.era';
import { eventStateSelector } from '../store/events.era';
import { accountStateSelector } from '../store/accounts.era';
import { Dictionary } from '@ngrx/entity';
import { filterAssets, programsByAssetIdsReselector } from '../store/reselectors/assets.reselector';
import { unfilteredFullMultiTimelineReselector } from '../store/reselectors/onsiteTimeline.reselector';
import { filterOnsiteTimelineFilters, filterTimeline, getOnsiteTimelineSets } from 'globals/share/onsite.filtering';
import { filterExhibitors } from '../store/exhibitors.functions';
import { Exhibitor, filterExhibitorStands, ProgramsExhibitors } from 'globals/store/exhibitors.data';
import { getStandIdsByExhibitorIds } from '../modules/program/program.helpers';
import { first, lastValueFrom, take } from 'rxjs';
import { filterResources, getResourcesWithQuotes, JoiResource } from 'globals/store/resources.data';
import { Attendee, filterAttendees } from 'globals/store/attendees.data';
import { TaskStatus } from 'globals/store/tasks.data';
import { exhibitorsStateSelector } from '../store/exhibitors.era';
import { exhibitorStandsStateSelector } from '../store/exhibitor.stands.era';
import { programsFeature, programsStateSelector } from '../store/programs.era';
import { sponsorsStateSelector } from '../store/sponsors.era';
import { filterProgramsSessionsByPerformers, filterProgramsSessionsBySponsors, ProgramsPerformersSponsors, ProgramsSponsors } from '../store/reselectors/performerSponsors.reselector';
import { tasksStateSelector } from '../store/tasks.era';
import { performersStateSelector } from '../store/performers.era';
import { resourcesStateSelector } from '../store/resources.era';
import { budgetStateSelector } from '../store/budget.era';
import { attendeesStateSelector } from '../store/attendees.era';
import { Asset } from 'globals/store/assets.data';
import { workforceStateSelector } from '../store/workforce.era';
import { filterHomeEvents, frontPageFilterUIDataReselector } from '../store/reselectors/filteredEvents.reselector';
import { filterTasks } from '../store/reselectors/filteredTasks.reselector';
import { filterPrograms, filterSnapshotPrograms } from 'globals/store/reselectors/filteredPrograms.reselector';
import { assetsFeature, assetsStateSelector } from '../store/assets.era';
import { OnsiteActivity } from 'globals/store/onsite.data';
// import { Attendee, filterAttendees } from '../store/attendees.data';
// import { userStateSelector } from '../store/user.era';
// import { filterStateSelector } from '../store/filters.era';
// import { accountStateSelector } from '../store/accounts.era';


  const TAG_EXCEPTION_FILTERS = [filterPageTypes.performersTable.toString(), filterPageTypes.performerSessionsTable.toString(), filterPageTypes.sponsors.toString(), filterPageTypes.sponsor_sessions,toString()]

  type FiltersMap = AllSameKeysEnforcer<FilterGroupGroups>

  const makeFiltersMap = (): FiltersMap => ({
    me: null,
    myResponsibility: null,
    myEvents: null,
    workforce: null,
    closed: null,
    flagged: null,
    entityIds: [],
    search: "",
    responsibilities: {},
    createdBy: {},
    visibilities: {},
    groupVisibilities: {},
    programs: {},
    schedules: {},
    sessions: {},
    accounts: {},
    performerLabels: {},
    programLabels: {},
    eventLabels: {},
    sessionLabels: {},
    taskLabels: {},
    activityLabels: {},
    tags: {},
    types: {},
    groupTags: {},
    performers: {},
    sponsorLabels: {},
    sponsors: {},
    exhibitorLabels: {},
    exhibitors: {},
    assetLabels: {},
    days: {},
    resources: {},
    resourceLabels: {},
    attendeeLabels: {},
    attendees: {},
    standalones: {},
    categories: {}
  })

  interface GroupVisibilityParams {
  filterGroups: FiltersGroupUI[]
  filterList: string[]
  groupNames: Set<string>
  filtersSubMap: any
  }

  interface CheckboxFiltersParams {
  filtersUIData: FiltersGroupingUI[]
  filters: FilterGroup
  idList?: Set<string>
  fetcher: Function
  type: string
  title?: string
  filtersSubMap: any
  sortedIds?: string[]
  }

  interface OneDeepCheckbox {
    pId: string // pId now refers to any parent id
    order: number
    sIds: string[] // sIds now refers to any nested ids, was originally schedule
    type: 'schedules' | 'days'
    isDate?: boolean
  }

  interface OneDeepCheckboxFiltersParams extends CheckboxFiltersParams {
  oneDeepFetcher: (id: string) => any
  oneDeepType: string
  oneDeepFiltersSubMap: any,
  oneDeepList: OneDeepCheckbox[]
  }


  interface LabelFiltersParams {
  filtersUIData: FiltersGroupingUI[]
  filters: FilterGroup
  attendeeLabels?: Set<string>
  performerLabels?: Set<string>
  sponsorLabels?: Set<string>
  programLabels?: Set<string>
  resourceLabels?: Set<string>
  sessionLabels?: Set<string>
  activityLabels?: Set<string>
  exhibitorLabels?: Set<string>
  taskLabels?: Set<string>
  filtersMap: FiltersMap,
  programLabelFetcher?: Function
  sessionLabelFetcher?: Function
  activityLabelFetcher?: Function
  taskLabelFetcher?: Function
  labelMaps: LabelMaps
  }

  interface TagFiltersParams {
  filters: FilterGroup
  filtersUIData: FiltersGroupingUI[]
  filtersMap: FiltersMap
  groupTags?: Set<string>
  tags?: Set<string>
  attendeeIds?: Set<string>
  attendeeEntities?: Dictionary<Attendee>
  resourceIds?: Set<string>
  resourceEntities?: Dictionary<JoiResource>
  performerIds?: Set<string>
  performerEntities?: Dictionary<Performer>
  sponsorIds?: Set<string>
  sponsorEntities?: Dictionary<Sponsor>
  exhibitorIds?: Set<string>
  exhibitorEntities?: Dictionary<Exhibitor>
  onRight: boolean
  workersByEmail?: { [key: string]: WFWorker }
  }

  interface TagFilterParams extends TagFiltersParams {
  title: string
  emptyTitle: string
  sort?: boolean
  skipSearchTerm?: boolean
  }


  export interface FrontPageFilterUIParams {
    accountList: Account[]
    inactiveAccountsList: Account[]
    publicInfoList: AccountPublicInfo[]
    accountIdsList?: string[]
    you?: User
    usedAccountLabelSetsByAccountId: { [id: string]: Set<string> }
    filters?: FilterGroup
    accountLabelListsByAccountId: { key: Label[] }
    inactiveAccountIdSet?: Set<string>
  }


  // // This takes a filter group name and tells the filtering function what the name of the set is from the set extraction functions
  const filterGroupNameToSetName = {
  [filterTypes.responsibilities]: "responsibilityEmails",
  [filterTypes.visibilities]: "visibleToEmails",
  [filterTypes.createdBy]: "createdByUIDs",
  [filterTypes.taskLabels]: "taskLabels",
  [filterTypes.programLabels]: "programLabels",
  [filterTypes.sessionLabels]: "sessionLabels",
  [filterTypes.eventLabels]: "usedAccountLabelsByAccountId",
  [filterTypes.accounts]: "allAccountIds",
  [filterTypes.programs]: "programIds",
  [filterTypes.groupVisibilities]: "groupVisibilityNames",
  [filterTypes.schedules]: "scheduleIds",
  [filterTypes.activityLabels]: "activityLabels",
  [filterTypes.groupTags]: "groupTags",
  [filterTypes.tags]: "tags",
  [filterTypes.performerLabels]: "performerLabels",
  [filterTypes.performers]: "performerIds",
  [filterTypes.sponsors]: "sponsorIds",
  [filterTypes.sponsorLabels]: "sponsorLabels",
  [filterTypes.exhibitors]: "exhibitorIds",
  [filterTypes.exhibitorLabels]: "exhibitorLabels",
  [filterTypes.days]: "dayIds",
  [filterTypes.assetLabels]: "assetLabels",
  [filterTypes.resourceLabels]: "resourceLabels",
  [filterTypes.resources]: "resourceIds",
  [filterTypes.attendeeLabels]: "attendeeLabels",
  [filterTypes.attendees]: "attendeeIds"
  }

  const isSelected = (selectedList, item): boolean => !selectedList ? false : selectedList.includes(item)

  const getProgramDaysOneDeepList = (programs: Program[]): OneDeepCheckbox[] => programs.map(p => {
    const programDayOneDeepCheckbox: OneDeepCheckbox = { pId: p.id, sIds: [], type: 'days', isDate: !!p.date, order: p.order }
    for (let d = 1; d <= p.days; d++) programDayOneDeepCheckbox.sIds.push(`${p.id}:${d}`)
    return programDayOneDeepCheckbox
  })

  /***
   * Despite its name, this service is used entirely for the rendering and updating of filters menus' ui
   * (not for managing the state of selected filters; that is done through filters.era and other store files)
  */
  @Injectable({ providedIn: 'root' })
  export class FiltersService {

  private filtersMaps: Partial<AllSameKeysEnforcer<FilterGroupGroups>> = {}
  private snapshotPrograms = []

  constructor(
    public store: Store,
    private uiService: UiService,
  ) { }


  readonly storeObject = computed(() => ({
    user: this.store.selectSignal(userStateSelector)()?.user,
    assets: this.store.selectSignal(assetsStateSelector)(),
    filters: this.store.selectSignal(filterStateSelector)(),
    events: this.store.selectSignal(eventStateSelector)(),
    accounts: this.store.selectSignal(accountStateSelector)(),
    exhibitors: this.store.selectSignal(exhibitorsStateSelector)(),
    exhibitorStands: this.store.selectSignal(exhibitorStandsStateSelector)(),
    programs: this.store.selectSignal(programsStateSelector)(),
    sponsors: this.store.selectSignal(sponsorsStateSelector)(),
    tasks: this.store.selectSignal(tasksStateSelector)(),
    performers: this.store.selectSignal(performersStateSelector)(),
    resources: this.store.selectSignal(resourcesStateSelector)(),
    budget: this.store.selectSignal(budgetStateSelector)(),
    attendees: this.store.selectSignal(attendeesStateSelector)(),
    workforce: this.store.selectSignal(workforceStateSelector)(),
  }))

  // storeObject = () => ({
  //   user: userStateSelector(this.store)?.user,
  //   assets: assetsStateSelector(this.store),
  //   filters: filterStateSelector(this.store),
  //   events: eventStateSelector(this.store),
  //   accounts: accountStateSelector(this.store),
  //   exhibitors: exhibitorsStateSelector(this.store),
  //   exhibitorStands: exhibitorStandsStateSelector(this.store),
  //   programs: programsStateSelector(this.store),
  //   sponsors: sponsorsStateSelector(this.store),
  //   tasks: tasksStateSelector(this.store),
  //   performers: performersStateSelector(this.store),
  //   resources: resourcesStateSelector(this.store),
  //   budget: budgetStateSelector(this.store),
  //   attendees: attendeesStateSelector(this.store),
  //   workforce: workforceStateSelector(this.store),
  // });

  async disableEnableFilters(filterPageType: string, filters: FilterGroup) {
    // remember, filters are not updated through the state until the update filters button is pressed
    const filtersMap = this.filtersMaps[filterPageType]
    const { filters: allFilters, user, tasks, programs, performers, sponsors, exhibitors, events, accounts, exhibitorStands, resources, budget, attendees } = await this.storeObject();
    
    const you = user.user
    const toggleFilters = allFilters.toggleFilters[filterPageType]

    let unfilteredMultiTimeline: DateSchedule[]
    if (filterPageType === filterPageTypes.onsiteTimeline || filterPageType === filterPageTypes.onsiteShare) {
      unfilteredMultiTimeline = await lastValueFrom(this.store.select(unfilteredFullMultiTimelineReselector).pipe(take(1)));
    }

    let programsByAssetIds: Dictionary<Program[]>
    if (filterPageType === filterPageTypes.asset_table) programsByAssetIds = await lastValueFrom(this.store.select(programsByAssetIdsReselector).pipe(take(1)));
    
    // console.log({ filtersMap })
    Object.entries(filtersMap).forEach(([name, subFilters]) => {
      let filteredSets, filteredItems
      switch (filterPageType) {
        case filterPageTypes.onsiteTimeline: {
          filteredItems = filterTimeline(unfilteredMultiTimeline, { ...filters, [name]: null }, true, exhibitors.entities, 'oss', exhibitorStands.entities, programs.entities)
          filteredSets = getOnsiteTimelineSets(filteredItems as DateSchedule[], exhibitors.entities, events.event.exhibitorStands)
          break
        }
        case filterPageTypes.onsiteShare: {
          filteredItems = filterTimeline(unfilteredMultiTimeline, { ...filters, [name]: null }, true, exhibitors.entities, 'oss', exhibitorStands.entities, programs.entities)
          filteredSets = getOnsiteTimelineSets(filteredItems as DateSchedule[], exhibitors.entities, events.event.exhibitorStands)
          // if (["schedules", "programs", "performers"].includes(name)) console.log({ name, filteredItems, unfilteredMultiTimeline, filteredSets, subFilters })
          break
        }
        case filterPageTypes.exhibitors: {
          filteredItems = filterExhibitors({ ...filters, [name]: null }, programs.entities, Object.values(exhibitors.entities), events.event)
          filteredSets = this.filterExhibitorSetsByPrograms(filteredItems, events.event)
          break
        }
        case filterPageTypes.exhibitor_stands: {
          filteredItems = filterExhibitorStands({ ...filters, [name]: null }, programs.entities, Object.values(events.event.exhibitorStands),  events.event.exhibitors)
          filteredSets = this.filterExhibitorSetsByPrograms(filteredItems, events.event, true)
          break
        }
        case filterPageTypes.sponsors:
          filteredItems = filterProgramsSessionsBySponsors(sponsors.entities, Object.values(programs.entities), { ...filters, [name]: null })
          filteredSets = this.filterSessionProgramSetsBySponsor(filteredItems)
          break
        case filterPageTypes.sponsor_sessions:
          filteredItems = filterProgramsSessionsBySponsors(sponsors.entities, Object.values(programs.entities), { ...filters, [name]: null })
          filteredSets = this.filterSponsorSetsBySessionsPrograms(filteredItems)
          break
        case filterPageTypes.performersTable:
          filteredItems = filterProgramsSessionsByPerformers(performers.entities, sponsors.entities, Object.values(programs.entities), { ...filters, [name]: null })
          filteredSets = this.filterSessionProgramSetsByPerformer(filteredItems)
          break
        case filterPageTypes.performerSessionsTable:
          filteredItems = filterProgramsSessionsByPerformers(performers.entities, sponsors.entities, Object.values(programs.entities), { ...filters, [name]: null })
          filteredSets = this.filterPerformerSetsBySessionsPrograms(filteredItems)
          break
        case filterPageTypes.asset_table:
          filteredItems = filterAssets(Object.values(events.event?.assets || {}), { ...filters, [name]: null }, toggleFilters, you, programsByAssetIds)
          filteredSets = this.getAssetSets(filteredItems, Object.values(programs.entities), you)
          break
        case filterPageTypes.tasksSidebar:
        case filterPageTypes.tasksCalendar:
        case filterPageTypes.allTasks:
        case filterPageTypes.allTasksCalendar:
        case filterPageTypes.tasks:
        case filterPageTypes.tasksTable:
        case filterPageTypes.taskTime:
          const taskList = Object.values(tasks.entities)
          let prefilteredTasks = filterPageType === filterPageTypes.taskTime ? filterTimeTasks(taskList, you) : taskList
          if ([filterPageTypes.allTasks, filterPageTypes.allTasksCalendar].map(t => t as string).includes(filterPageType)) {
            const filteredEventIds = filterHomeEvents(filters, Object.values(events.entities), false, accounts, you).map(e => e.eventId)
            prefilteredTasks = prefilteredTasks.filter(t => filteredEventIds.includes(t.eventId))
          }
          filteredItems = filterTasks(prefilteredTasks, { ...filters, [name]: null }, toggleFilters, you)
          filteredSets = this.getTaskSets(filteredItems, you)
          break
        case filterPageTypes.programLogistics:
          filteredItems = filterPrograms(Object.values(programs.entities), { ...filters, [name]: null })
          filteredSets = this.getProgramTimelineSets(filteredItems, Object.values(performers.entities), Object.values(sponsors.entities))
          break
        case filterPageTypes.programTimeline:
          filteredItems = filterPrograms(Object.values(programs.entities), { ...filters, [name]: null })
          filteredSets = this.getProgramTimelineSets(filteredItems, Object.values(performers.entities), Object.values(sponsors.entities))
          break
        case filterPageTypes.publish: // I think this is wrong to pass the filtering to the programTimeline / programContent filtering function
          filteredItems = filterPrograms(Object.values(programs.entities), { ...filters, [name]: null })
          filteredSets = this.getProgramTimelineSets(filteredItems, Object.values(performers.entities), Object.values(sponsors.entities), false)
          break
        case filterPageTypes.programTimelineSnapshot:
          filteredItems = filterSnapshotPrograms(this.snapshotPrograms, { ...filters, [name]: null })
          filteredSets = this.getProgramTimelineSnapshotSets(filteredItems)
          break
        case filterPageTypes.resources:
          filteredItems = filterResources({ ...filters, [name]: null }, Object.values(resources.entities))
          filteredSets = this.filterResourceSets(filteredItems)
          break
        case filterPageTypes.quotes:
          filteredItems = filterResources({ ...filters, [name]: null }, getResourcesWithQuotes(Object.values(resources.entities), budget.budget))
          filteredSets = this.filterResourceSets(filteredItems)
          break
        case filterPageTypes.attendees:
          filteredItems = filterAttendees({ ...filters, [name]: null }, Object.values(attendees.entities))
          filteredSets = this.filterAttendeeSets(filteredItems)
          break
        case filterPageTypes.programTable:
          break
        default:
          console.log(`Disabling of filters not configured for ${filterPageType}`)
          return
      }
      const filterType = name as keyof FilterGroup
      const isOnsite = filterPageType === filterPageTypes.onsiteTimeline || filterPageType === filterPageTypes.onsiteShare
      switch (filterType) {
        case 'tags': // don't deselect tags ==> getting the logic to work inclusively between tags and groupTags and exclusively between everything else would be a bit of work, so leaving them always selectable for now
          if (TAG_EXCEPTION_FILTERS.includes(filterPageType)) {
            // in the case of performers table or sessions table, 'tags' are the workforce contact, and there is no problem as described above
            this.disableFilters(subFilters, filteredSets, filterType)
          }
          break
        case 'eventLabels':
          break
        case 'accounts':
          break
        case 'groupTags': // don't deselect groupTags
          break
        case 'days': // don't deselect days
          break
        case "me":
          break
        case 'myResponsibility':
          break
        case "myEvents":
          break
        case "flagged":
          break
        case "closed":
          break
        case "workforce":
          break
        case "programs":
          break
        case "schedules":
          break

        // These flow through to default case unless onsite
        case "activityLabels":
          if (isOnsite) break
        case "sessionLabels":
          if (isOnsite) break
        case "programLabels":
          if (isOnsite) break
        default:
          this.disableFilters(subFilters, filteredSets, filterType)
          break

      }
    })
  }
  private disableFilters(subFilters, filteredSets, name) {

    const filterGroupName = filterGroupNameToSetName[name]
    const flattenedFilters: FilterUI[] = Object.values(subFilters)

    let selectedCount = 0 // These are necessary to avoid logically consistent states but very UI
    let disabledOrUnselectedCount = 0 // unfriendly ones, where it's hard to select yourself back out of your current selections
    flattenedFilters.forEach((filter: FilterUI) => {
      if (!filteredSets[filterGroupName]) {
        console.log("Missing a filtered set that should exist (perhaps you should check filterGroupNameToSetName to make sure the entry exists -- look in filteredSets to find the likely solution): ", { name, filterGroupName, filteredSets })
      } else {
        selectedCount += filter.selected ? 1 : 0
        filter.disabled = !filteredSets[filterGroupName].has(filter.id)
        // console.log({ filterId: filter.id, name, disabled: filter.disabled, filterGroupName })
        disabledOrUnselectedCount += filter.disabled || !filter.selected ? 1 : 0
      }
    })

    // if (["schedules", "programs", "performers"].includes(name)) console.log({ name, subFilters, filteredSets, flattenedFilters: jsonCopyObject(flattenedFilters), selectedCount, disabledOrUnselectedCount })

    if (selectedCount > 0 && disabledOrUnselectedCount === flattenedFilters.length) {
      // console.log("RE-ENABLING FILTERS")
      flattenedFilters.forEach(filter => {
        if (filter.selected) {
          filter.disabled = false
        }
      })
    }

  }
  private addMetaFilters(filtersUIData: FiltersGroupingUI[], filters: FilterGroup, filtersMap: FiltersMap, you, isAssets = false) {
    const metaFilters: FilterUI[] = []

    // Always add me and flagged in meta filters, no matter what, per Tony
    // if (tasks.filter(t => (t.createdBy === you.uid && !t.responsibility) || t.responsibility === you.email).length !== 0) {
      filtersMap.me = { name: isAssets ? MY_CREATED_ASSETS : MY_CREATED_TASKS, id: you.uid, selected: !!filters.me, type: FilterUIType.PhotoLabel, photoData: you }
      metaFilters.push(filtersMap.me)
      filtersMap.myResponsibility = { name: isAssets ? MY_RESPONSIBLE_ASSETS : MY_RESPONSIBLE_TASKS, id: you.uid, selected: !!filters.myResponsibility, type: FilterUIType.PhotoLabel, photoData: you }
      metaFilters.push(filtersMap.myResponsibility)

    // }
    // if (tasks.filter(t => t.flag).length !== 0) {
      filtersMap.flagged = { name: isAssets ? FLAGGED_ASSETS : FLAGGED_TASKS, id: you.uid, selected: !!filters.flagged, type: FilterUIType.Icon, matIconName: 'flagon' }
      metaFilters.push(filtersMap.flagged)
    // }

    filtersUIData.push({
      filterGroups: [
        {
          groupId: 'Meta', // Don't change this id
          filters: metaFilters
        }
      ]
    })
  }
  private addMyEvents(filtersUIData: FiltersGroupingUI[], filters: FilterGroup, filtersMap, you: User) {

    // TODO: add checks to see if each of these checkboxes is a possible option?
    const metaFilters: FilterUI[] = []
    filtersMap.myEvents = { name: MY_EVENTS, id: you.uid, selected: !!filters.myEvents, type: FilterUIType.PhotoLabel, photoData: you }
    metaFilters.push(filtersMap.myEvents)
    /*     filtersMap.closed = { name: 'Show closed events', id: 'closed', selected: !!filters.closed, type: FilterUIType.Checkbox }
        metaFilters.push(filtersMap.closed) */
    filtersUIData.push({
      filterGroups: [
        { hideTitle: true, groupId: 'Meta', filters: metaFilters }
      ]
    })
  }
  private getPeopleFilterGroup({ idType, filterList, userMap, possibleList, yourLabel = null, filtersSubMap, you }, hideYou = false): FilterUI[] {

    // console.log({ idType, possibleList })
    const filteredList: FilterUI[] = Array.from(possibleList).map(idItem => {
      const user = userMap[<string>idItem]
      if (!user) {
        console.log(`Missing user with ${idType}: ${idItem}`, { possibleList, userMap })
        return // necessitates filter below to avoid empty entries
      }
      const filter = { name: nameJoiner(user), type: FilterUIType.PhotoLabel, photoData: user, id: user[idType], selected: isSelected(filterList, user[idType]) }
      filtersSubMap[<string>idItem] = filter
      return filter
    }).filter(item => item && item.id !== you)

    filteredList.sort((a, b) => a.photoData.firstName < b.photoData.firstName ? -1 : 1)

    const yourFilter: FilterUI = yourLabel ? { name: yourLabel, id: you[idType], type: FilterUIType.PhotoLabel, photoData: you, selected: isSelected(filterList, you[idType]) } : undefined
    if (yourFilter) {
      filtersSubMap[you.id] = yourFilter
    }
    return yourFilter && !hideYou ? [yourFilter, ...filteredList] : filteredList

  }
  private addGroupVisibilities({ filterGroups, filterList, groupNames, filtersSubMap }: GroupVisibilityParams) {
    const omegaGroup: FilterUI = { name: OMEGA_GROUP_NAME, id: OMEGA_GROUP_ID, type: FilterUIType.Icon, matIconName: 'group24', selected: isSelected(filterList, OMEGA_GROUP_ID) }
    filtersSubMap[OMEGA_GROUP_ID] = omegaGroup

    const groupFilters: FilterUI[] = Array.from(groupNames).map(groupName => {
      const groupFilter = { name: groupName, id: groupName, type: FilterUIType.Icon, matIconName: 'group24', selected: isSelected(filterList, groupName) }
      filtersSubMap[groupName] = groupFilter
      return groupFilter
    })

    filterGroups.push({
      title: 'Visible to Permissions',
      groupId: filterTypes.groupVisibilities,
      filters: [omegaGroup]
    })

    filterGroups.push({
      title: 'Visible to Groups',
      groupId: filterTypes.groupVisibilities,
      filters: groupFilters
    })

  }

  private addLabelFilterGroup({ filterList, labelFetcher, possibleLabels, filtersSubMap }): FilterUI[] {
    return Array.from(possibleLabels).filter(labelId => labelFetcher(labelId)).map(labelId => {
      const { label, color, name, id } = labelFetcher(labelId)
      const labelFilter: FilterUI = {
        name: label || name,
        id,
        color,
        type: FilterUIType.ColoredLabel,
        selected: isSelected(filterList, labelId)
      }
      filtersSubMap[<string>labelId] = labelFilter
      return labelFilter
    }).sort((labelFilterA, labelFilterB) => this.uiService.sortLabels(
      { color: labelFilterA.color, label: labelFilterA.name } as Label,
      { color: labelFilterB.color, label: labelFilterB.name } as Label))
  }
  private addLabelFilters({ filtersUIData, filters, performerLabels, sponsorLabels, programLabels, exhibitorLabels, sessionLabels, activityLabels, taskLabels, filtersMap, programLabelFetcher, sessionLabelFetcher, activityLabelFetcher, taskLabelFetcher, labelMaps, resourceLabels, attendeeLabels }: LabelFiltersParams) {
    const filterGroups: FiltersGroupUI[] = []

    if (exhibitorLabels) {
      const labelFetcher = (id) => labelMaps.exhibitor_labels[id]
      filterGroups.push({
        title: 'Exhibitor Labels',
        groupId: filterTypes.exhibitorLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.exhibitorLabels,
          labelFetcher,
          possibleLabels: exhibitorLabels,
          filtersSubMap: filtersMap[filterTypes.exhibitorLabels]
        })
      })
    }

    if (attendeeLabels) {
      const labelFetcher = (id) => labelMaps.attendee_labels[id]
      filterGroups.push({
        title: 'Attendee Labels',
        groupId: filterTypes.attendeeLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.attendeeLabels,
          labelFetcher,
          possibleLabels: attendeeLabels,
          filtersSubMap: filtersMap[filterTypes.attendeeLabels]
        })
      })
    }

    if (resourceLabels) {
      const labelFetcher = (id) => labelMaps.resource_labels[id]
      filterGroups.push({
        title: 'Resource Labels',
        groupId: filterTypes.resourceLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.resourceLabels,
          labelFetcher,
          possibleLabels: resourceLabels,
          filtersSubMap: filtersMap[filterTypes.resourceLabels]
        })
      })
    }

    if (sponsorLabels) {
      const labelFetcher = (id) => labelMaps.sponsor_labels[id]
      filterGroups.push({
        title: 'Sponsor Labels',
        groupId: filterTypes.sponsorLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.sponsorLabels,
          labelFetcher,
          possibleLabels: sponsorLabels,
          filtersSubMap: filtersMap[filterTypes.sponsorLabels]
        })
      })
    }

    if (performerLabels) {
      const labelFetcher = (id) => labelMaps.performer_labels[id]
      filterGroups.push({
        title: 'Performer Labels',
        groupId: filterTypes.performerLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.performerLabels,
          labelFetcher,
          possibleLabels: performerLabels,
          filtersSubMap: filtersMap[filterTypes.performerLabels]
        })
      })
    }

    if (programLabels) {
      const labelFetcher = programLabelFetcher ? programLabelFetcher : (id) => labelMaps.program_labels[id]
      filterGroups.push({
        title: 'Program Labels',
        groupId: filterTypes.programLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.programLabels,
          labelFetcher,
          possibleLabels: programLabels,
          filtersSubMap: filtersMap[filterTypes.programLabels]
        })
      })
    }

    if (sessionLabels) {
      const labelFetcher = sessionLabelFetcher ? sessionLabelFetcher : (id) => labelMaps.session_labels[id]
      filterGroups.push({
        title: 'Session Labels',
        groupId: filterTypes.sessionLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.sessionLabels,
          labelFetcher,
          possibleLabels: sessionLabels,
          filtersSubMap: filtersMap[filterTypes.sessionLabels]
        })
      })
    }

    if (activityLabels) {
      const labelFetcher = activityLabelFetcher ? activityLabelFetcher : (id) => labelMaps.activity_labels[id]
      filterGroups.push({
        title: 'Activity Labels',
        groupId: filterTypes.activityLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.activityLabels,
          labelFetcher,
          possibleLabels: activityLabels,
          filtersSubMap: filtersMap[filterTypes.activityLabels]
        })
      })
    }

    if (taskLabels) {
      const labelFetcher = taskLabelFetcher ? taskLabelFetcher : (id) => labelMaps.task_labels[id]
      filterGroups.push({
        title: 'Task Labels',
        groupId: filterTypes.taskLabels,
        filters: this.addLabelFilterGroup({
          filterList: filters.taskLabels,
          labelFetcher,
          possibleLabels: taskLabels,
          filtersSubMap: filtersMap[filterTypes.taskLabels]
        })
      })
    }

    filtersUIData.push({
      title: 'Labels',
      filterGroups
    })
  }
  private addOneDeepCheckBoxFilterGroup({ filtersUIData, filters, oneDeepList, fetcher, oneDeepFetcher, type, oneDeepType, title, filtersSubMap, oneDeepFiltersSubMap }: OneDeepCheckboxFiltersParams) {

    const checkboxes = []
    oneDeepList.forEach(({ pId, sIds, isDate }) => {
      const parentCheckboxFilter = {
        type: FilterUIType.Checkbox,
        name: fetcher(pId),
        id: pId,
        selected: isSelected(filters[type], pId),
        innerGroupId: type
      }
      checkboxes.push(parentCheckboxFilter)
      filtersSubMap[pId] = parentCheckboxFilter
      sIds.forEach(sId => {
        const childCheckboxFilter: FilterUI = {
          type: FilterUIType.SubCheckbox,
          name: oneDeepFetcher(sId),
          id: sId,
          selected: isSelected(filters[oneDeepType], sId),
          innerGroupId: oneDeepType,
          isDate: !!isDate,
          parentId: pId
        }
        checkboxes.push(childCheckboxFilter)
        oneDeepFiltersSubMap[sId] = childCheckboxFilter
      })
    })

    filtersUIData.push({
      title,
      filterGroups: [
        { hideTitle: true, title: checkboxes.length === 0 ? title : null, groupId: null, filters: checkboxes }
      ]
    })

  }
  private addCheckBoxFilterGroup({ filtersUIData, filters, idList, fetcher, type, title, filtersSubMap, sortedIds }: CheckboxFiltersParams, isStandalone=false) {

    const ids = sortedIds || Array.from(idList)
    const checkboxes = ids.map(id => {
      const element = fetcher(id)
      const checkBoxFilter = {
        type: FilterUIType.Checkbox,
        name: element ? element.title : '',
        id,
        selected: isSelected(filters[type], id),
      }
      filtersSubMap[<string>id] = checkBoxFilter
      return checkBoxFilter
    })
    filtersUIData.push({
      title,
      filterGroups: [
        { hideTitle: true, title: checkboxes.length === 0 ? title : null, groupId: type, filters: checkboxes }
      ]
    })
  }
  // created to also use for performers table contacts
  private addTagFilterGroup({ filters, filtersMap, filtersUIData, tags, workersByEmail, title, emptyTitle, onRight, sort, skipSearchTerm }: TagFilterParams) {
    const peopleFilters = this.getPeopleFilterGroup({
      idType: 'email',
      filterList: filters.tags,
      userMap: workersByEmail,
      possibleList: tags,
      filtersSubMap: filtersMap[filterTypes.tags],
      you: null
    })

    !skipSearchTerm && peopleFilters.forEach(personFilter => {
      const { email, firstName, lastName, role } = workersByEmail[personFilter.id]
      personFilter.searchTerm = `${email} ${firstName || ''} ${lastName || ''} ${role || ''}`.toLocaleLowerCase()
    })
    
    sort && peopleFilters.sort(sortByProp('name'))

    filtersUIData.push({
      title,
      rightColumn: onRight,
      filterGroups: [{
        title: emptyTitle,
        hideTitle: true,
        groupId: filterTypes.tags,
        filters: peopleFilters
      }]
    })
  }
  private addTagFilterGroups({ filters, filtersMap, filtersUIData, groupTags, tags, performerIds, performerEntities, workersByEmail, onRight, sponsorIds, sponsorEntities, exhibitorIds, exhibitorEntities, resourceIds, resourceEntities, attendeeEntities, attendeeIds }: TagFiltersParams) {

    // console.log({ groupTags })
    groupTags && filtersUIData.push({
      title: 'Groups',
      rightColumn: onRight,
      filterGroups: [{
        title: 'groups tagged',
        hideTitle: true,
        groupId: filterTypes.groupTags,
        filters: !groupTags.size ? [] : Array.from(groupTags).map(groupName => {
          const groupFilter = {
            name: groupName,
            id: groupName,
            type: FilterUIType.Icon,
            matIconName: 'group24',
            selected: isSelected(filters.groupTags, groupName)
          }
          filtersMap.groupTags[groupName] = groupFilter
          return groupFilter
        })
      }]
    })
    tags && this.addTagFilterGroup({ filters, filtersMap, filtersUIData, tags, workersByEmail, title: 'Workforce', emptyTitle: 'workforce tagged', onRight })

    console.log({ attendeeIds, attendeeEntities })
    if (attendeeIds) {
      const attendeeFilters = {
        title: 'Attendees',
        rightColumn: onRight,
        filterGroups: [{
          title: 'attendees',
          hideTitle: true,
          groupId: filterTypes.attendees,
          filters: !attendeeIds.size ? [] : Array.from(attendeeIds).filter(rId => attendeeEntities[rId]).map(id => {
            const { name } = attendeeEntities[id]
            const attendeeFilter = {
              name,
              id,
              type: FilterUIType.PhotoLabel,
              selected: isSelected(filters.attendees, id)
            }
            filtersMap.attendees[id] = attendeeFilter
            return attendeeFilter
          })
        }]
      }
      attendeeFilters.filterGroups[0].filters.sort(sortByProp('name'))
      filtersUIData.push(attendeeFilters)
    }

    if (performerIds) {
      const performerFilters = {
        title: 'Performers',
        rightColumn: onRight,
        filterGroups: [{
          title: 'performers',
          hideTitle: true,
          groupId: filterTypes.performers,
          filters: !performerIds.size ? [] : Array.from(performerIds).filter(pId => performerEntities[pId]).map(pId => {
            const performerFilter = {
              name: performerEntities[pId].name,
              id: pId,
              type: FilterUIType.PhotoLabel,
              photoData: {title: performerEntities[pId].name, photoURL: performerEntities[pId].photoUrl},
              selected: isSelected(filters.performers, pId)
            }
            filtersMap.performers[pId] = performerFilter
            return performerFilter
          })
        }]
      }
      performerFilters.filterGroups[0].filters.sort(sortByProp('name'))
      filtersUIData.push(performerFilters)
    }

    if (resourceIds) {
      const resourceFilters = {
        title: 'Resources',
        rightColumn: onRight,
        filterGroups: [{
          title: 'resources',
          hideTitle: true,
          groupId: filterTypes.resources,
          filters: !resourceIds.size ? [] : Array.from(resourceIds).filter(rId => resourceEntities[rId]).map(id => {
            const { name } = resourceEntities[id]
            const resourceFilter = {
              name,
              id,
              type: FilterUIType.PhotoLabel,
              selected: isSelected(filters.resources, id)
            }
            filtersMap.resources[id] = resourceFilter
            return resourceFilter
          })
        }]
      }
      resourceFilters.filterGroups[0].filters.sort(sortByProp('name'))
      filtersUIData.push(resourceFilters)
    }

    if (sponsorIds) {
      const sponsorFilters = {
        title: 'Sponsors',
        rightColumn: onRight,
        filterGroups: [{
          title: 'Sponsors',
          hideTitle: true,
          groupId: filterTypes.sponsors,
          filters: !sponsorIds.size ? [] : Array.from(sponsorIds).filter(sId => sponsorEntities[sId]).map(sId => {
            const sponsorFilter = {
              name: sponsorEntities[sId].name,
              id: sId,
              type: FilterUIType.PhotoLabel,
              // photoData: {title: sponsorEntities[sId].name, photoURL: sponsorEntities[sId].logoUrl},
              selected: isSelected(filters.sponsors, sId)
            }
            filtersMap.sponsors[sId] = sponsorFilter
            return sponsorFilter
          })
        }]
      }
      sponsorFilters.filterGroups[0].filters.sort(sortByProp('name'))
      filtersUIData.push(sponsorFilters)
    }

    if (exhibitorIds) {
      const exhibitorFilters = {
        title: 'Exhibitors',
        rightColumn: onRight,
        filterGroups: [{
          title: 'Exhibitors',
          hideTitle: true,
          groupId: filterTypes.exhibitors,
          filters: !exhibitorIds.size ? [] : Array.from(exhibitorIds).filter(eId => exhibitorEntities[eId]).map(eId => {
            const exhibitorFilter = {
              name: exhibitorEntities[eId].name,
              id: eId,
              type: FilterUIType.PhotoLabel,
              // photoData: {title: exhibitorEntities[eId].name, photoURL: exhibitorEntities[eId].logoUrl},
              selected: isSelected(filters.exhibitors, eId)
            }
            filtersMap.exhibitors[eId] = exhibitorFilter
            return exhibitorFilter
          })
        }]
      }
      exhibitorFilters.filterGroups[0].filters.sort(sortByProp('name'))
      filtersUIData.push(exhibitorFilters)
    }

  }

  private getTaskSets(tasks: Task[], user: User) {
    const responsibilityEmails = getSet(tasks, 'responsibility')
    responsibilityEmails.delete(user.email)
    const visibleToEmails = getNestedSet(tasks, 'visibility')
    visibleToEmails.delete(user.email)
    const createdByUIDs = getSet(tasks, 'createdBy')
    createdByUIDs.delete(user.uid)

    const taskLabels = getNestedSet(tasks, 'labels')
    const programIds = getSet(tasks, 'program')
    const groupVisibilityNames = getNestedSet(tasks, 'groupVisibility')
    const entityIds = getSet(tasks, 'entityId')

    return { responsibilityEmails, visibleToEmails, createdByUIDs, taskLabels, programIds, groupVisibilityNames, entityIds }
  }
  
  getProgramTimelineSets(programs: Program[], performerList: Performer[], sponsorList: Sponsor[], filterDates = true) {
    if (filterDates) programs = programs.filter(p => p.date)
    const sessions = flatten(programs.map(p => Object.values(p.sessions_obj)))
    const sessionPerformerIds = getNestedSet(sessions, 'performerIds')
    const sessionSponsorIds = getNestedSet(sessions, 'sponsorIds')
    const groupTags = getNestedSet(sessions, 'groupTags')
    const tags = getNestedSet(sessions, 'tags')
    const sessionLabels = getNestedSet(sessions, 'labels') // : Set<string> = new Set(sessions.flat(1).reduce((arr, session) => session.labels ? arr.concat(session.labels) : arr, []))
    const programLabels = getNestedSet(programs, 'labels')
    const programIds = getSet(programs, 'id')
    const dayIds: Set<string> = new Set()
    programs.forEach(p => {
      for (let d = 1; d <= p.days; d++) dayIds.add(`${p.id}:${d}`)
    })
    const performerIds = getSet(performerList.filter(p => sessionPerformerIds.has(p.id)), 'id')
    const sponsorIds = getSet(sponsorList.filter(s => sessionSponsorIds.has(s.id)), 'id')
    return { sessionLabels, programLabels, programIds, tags, dayIds, performerIds, groupTags, sponsorIds }
  }
  public async filterOnsiteShareFilters(filters: FilterGroup): Promise<FilterGroup> {
    
    const multiTimelines: DateSchedule[] = <DateSchedule[]> await lastValueFrom(this.store.select(unfilteredFullMultiTimelineReselector).pipe(take(1)));
    const { performers, sponsors, resources, events, workforce: { workforceGroupsById, workersByEmail }, exhibitors, attendees } = await this.storeObject();
    filterOnsiteTimelineFilters(filters, multiTimelines, performers.entities, events.labelMaps, workforceGroupsById, workersByEmail, sponsors.entities, exhibitors.entities, events.event.exhibitorStands, resources.entities, attendees.entities)
    return filters

  }
  public async filterPublishViewFilters(filters: FilterGroup): Promise<FilterGroup> {

    const { performers, programs, events, workforce, sponsors } = await this.storeObject();
    const { sessionLabels, programLabels, sponsorIds, programIds, performerIds, dayIds, tags, groupTags } = this.getProgramTimelineSets(Object.values(programs.entities), Object.values(performers.entities), Object.values(sponsors.entities), false)

    const { workforceGroupsById, workersByEmail } = workforce
    const { session_labels, program_labels, performer_labels, sponsor_labels, resource_labels, attendee_labels } = events.labelMaps

    filterFilters({ filters, workforceGroupsById, workersByEmail, session_labels, program_labels, programIds, sessionLabels, programLabels, tags, groupTags, dayIds, performerIds, performer_labels, sponsor_labels, sponsorIds, resource_labels, attendee_labels })
    return filters
  } 
  // Just a start to stop the errors
  public async filterShareOSSViewFilters(filters: FilterGroup): Promise<FilterGroup> {
    console.log('This function needs to be fleshed out.  Just a place holder for now')
    return filters
  }
  public filterAndLoadTimelineFilters(filters: FilterGroup, filterType: keyof FilterGroupTypes = 'publish') {
    // filters from a publish view could no longer be valid, and in that case, they would both not show up in the filters menu AND filter out everything by default

    if (!filters) {
      return this.store.dispatch(filterActions.clearFilterGroup(filterType)) // dispatch empty filter
    }
    this.filterPublishViewFilters(filters).then(filters => 
      this.store.dispatch(filterActions.updateFilters({ filterGroup: filterType, filters }))
    )
  }
  getProgramTimelineSnapshotSets(snapshotPrograms: any[]) {
    const programIds = getSet(snapshotPrograms, 'pID')
    const programLabels = getNestedSet(snapshotPrograms, 'prog_labels')
    const sessions = snapshotPrograms.reduce((sessions, p) => [...sessions, ...p.sessions], [])
    const sessionLabels = getNestedSet(sessions as any[], 'sess_labels')
    const performerIds = getNestedSet(sessions as any[], 'performerIds')
    // TODO: Add tags and groupTags into the old snapshot data format
    const groupTags = getNestedSet(sessions as any[], 'groupTags')
    const tags = getNestedSet(sessions as any[], 'tags')
    return { sessionLabels, programLabels, programIds, tags, groupTags, performerIds  }
  }
  getFrontPageTimelineSets(events: JoiEvent[], fullAccountIds: string[], publicInfos: AccountPublicInfo[]) {

    const allAccountIds = new Set(fullAccountIds)
    const eventAccountLabelIds: Set<string> = new Set(events.filter(e => e.labels).reduce((acc, { labels, accountId }) => [...acc, ...labels.map(l => `${l}|${accountId}`)], []))

    // console.log({ fullAccountIds, eventAccountLabelIds })

    publicInfos.forEach(info => allAccountIds.add(info.id))

    return { eventAccountLabelIds, allAccountIds }
  }

  filterSessionProgramSetsByPerformer({ performerList, programsList }: ProgramsPerformersSponsors) { // For performer table filters: should not show filters from sessions / programs that don't belong to any performer
    const performerLabels = getNestedSet(performerList, 'labels')
    const performerIds = getSet(performerList, 'id')
    const tags = getSet(performerList, 'contact')

    const programIds: Set<string> = new Set()
    const programLabels: Set<string> = new Set()
    const sessionLabels: Set<string> = new Set()
    programsList.forEach(p => {
      let hasSession = false
      Object.values(p.sessions_obj).filter(s => setIntersection(new Set(s.performerIds), performerIds).size).map(s => {
        hasSession = true
        s.labels && s.labels.forEach(l => sessionLabels.add(l))
      })
      if (hasSession) {
        programIds.add(p.id)
        p.labels && p.labels.forEach(l => programLabels.add(l))
      }
    })
    // console.log({ performerList, programsList, performerLabels, tags, programLabels, programIds, sessionLabels })
    return  { performerLabels, tags, programLabels, programIds, sessionLabels }   
  }

  filterSessionProgramSetsBySponsor({ sponsorList, programsList }: ProgramsSponsors) { // For sponsor table filters: should not show filters from sessions / programs that don't belong to any sponsor 
    const sponsorLabels = getNestedSet(sponsorList, 'labels')
    const sponsorIds = getSet(sponsorList, 'id')
    const tags = getSet(sponsorList, 'WFContact')

    const programIds: Set<string> = new Set()
    const programLabels: Set<string> = new Set()
    const sessionLabels: Set<string> = new Set()
    programsList.forEach(p => {
      let hasSponsorSession = false
      Object.values(p.sessions_obj).filter(s => setIntersection(new Set(s.sponsorIds), sponsorIds).size).map(s => {
        hasSponsorSession = true
        s.labels && s.labels.forEach(l => sessionLabels.add(l))
      })
      if (hasSponsorSession) {
        programIds.add(p.id)
        p.labels && p.labels.forEach(l => programLabels.add(l))
      }
    })
    return  { sponsorLabels, tags, programLabels, programIds, sessionLabels }   
  }
  filterSponsorSetsBySessionsPrograms({ sponsorList, programsList }: ProgramsSponsors) { // For session table filters: should not show filters from performers that don't belong to any session
    const programLabels = getNestedSet(programsList, 'labels')
    const programIds: Set<string> = getSet(programsList, 'id')
    const sessionLabels: Set<string> = new Set()
    const addedSponsorIds: Set<string> = new Set()
    programsList.forEach(p => Object.values(p.sessions_obj).forEach(s => {
      s.labels && s.labels.forEach(l => sessionLabels.add(l))
      s.sponsorIds && s.sponsorIds.forEach(id => addedSponsorIds.add(id))
    }))
    const filteredSponsorList = sponsorList.filter(p => addedSponsorIds.has(p.id))
    const sponsorLabels = getNestedSet(filteredSponsorList, 'labels')
    const tags = getSet(filteredSponsorList, 'WFContact')

    return  { sponsorLabels, tags, programLabels, programIds, sessionLabels }   

  }
  filterPerformerSetsBySessionsPrograms({ performerList, programsList, sponsorList }: ProgramsPerformersSponsors) { // For session table filters: should not show filters from performers that don't belong to any session
    // console.log({ performerList, programsList, sponsorList })
    const programLabels = getNestedSet(programsList, 'labels')
    const programIds: Set<string> = getSet(programsList, 'id')
    const sessionLabels: Set<string> = new Set()
    const addedPerformerIds: Set<string> = new Set()
    const addedSponsorIds: Set<string> = new Set()
    programsList.forEach(p => Object.values(p.sessions_obj).forEach(s => {
      s.labels && s.labels.forEach(l => sessionLabels.add(l))
      s.performerIds && s.performerIds.forEach(id => addedPerformerIds.add(id))
      s.sponsorIds && s.sponsorIds.forEach(id => addedSponsorIds.add(id))
    }))
    const filteredPerformerList = performerList.filter(p => addedPerformerIds.has(p.id))
    const performerLabels = getNestedSet(filteredPerformerList, 'labels')
    const filteredSponsorList = sponsorList.filter(p => addedSponsorIds.has(p.id))
    const sponsorLabels = getNestedSet(filteredSponsorList, 'labels')
    const tags = getSet(filteredPerformerList, 'contact')
    return  { performerLabels, sponsorLabels, tags, programLabels, programIds, sessionLabels }   
  }

  filterExhibitorSetsByPrograms({ exhibitorList, programList }: ProgramsExhibitors, event: JoiEvent, isStands = false) {
    const programIds: Set<string> = new Set()
    const allProgramIds = getSet(programList, 'id')

    Object.values(event.exhibitorStands)
      .filter(s => s.programId && (isStands || s.exhibitorId) && allProgramIds.has(s.programId))
      .forEach(({ programId }) => programIds.add(programId))

    const filteredPrograms = programList.filter(p => programIds.has(p.id))
    const programLabels = getNestedSet(filteredPrograms, 'labels')

    if (isStands) {
      const standIdsByExhibitorIds = getStandIdsByExhibitorIds(event.exhibitorStands)
      exhibitorList = exhibitorList.filter(e => !!standIdsByExhibitorIds[e.id])
    }

    const exhibitorLabels = getNestedSet(exhibitorList, 'labels')
    const tags = getSet(exhibitorList, 'workforceContactEmail')

    return { exhibitorLabels, tags, programLabels, programIds }
  }

  filterResourceSets(resourceList: Array<JoiResource>) {
    const resourceLabels = getNestedSet(resourceList, 'labels')
    const tags = getSet(resourceList, 'workforceContactEmail')
    return { resourceLabels, tags }
  }

  filterAttendeeSets(attendeeList: Array<Attendee>) {
    const attendeeLabels = getNestedSet(attendeeList, 'labels')
    const tags = getSet(attendeeList, 'WFContact')
    return { attendeeLabels, tags }
  }

  async buildAttendeeTableFilterUI(): Promise<FiltersGroupingUI[]> { 
    const { filters: allFilters, attendees, workforce, events, budget } = await this.storeObject();
    const filters = allFilters.attendees
    const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()
    const event = events.event

    // Store references to necessary information for enabling / disabling filters
    this.filtersMaps[filterPageTypes.attendees] = filtersMap
    let attendeeList = Object.values(attendees.entities)

    const { attendeeLabels, tags } = this.filterAttendeeSets(attendeeList)
    const { workersByEmail } = workforce

    this.addTagFilterGroup({ filters, filtersMap, filtersUIData, tags, workersByEmail, title: 'Workforce Contact', emptyTitle: 'workforce contacts added', onRight: true, sort: true })
    this.addEntityTypes(filters, filtersMap, filtersUIData, getSet(attendeeList, 'entityTypeId'), event.attendeeTypes, 'Attendee Types')

    this.addLabelFilters({ filtersUIData, filters, attendeeLabels, filtersMap, labelMaps: events.labelMaps })
    return filtersUIData
  }

  async buildResourceTableFilterUI(isQuotes: boolean): Promise<FiltersGroupingUI[]> { 
    const { filters: allFilters, resources, workforce, events, budget } = await this.storeObject();
    const filters = isQuotes ? allFilters.quotes : allFilters.resources
    const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()

    // Store references to necessary information for enabling / disabling filters
    this.filtersMaps[isQuotes ? filterPageTypes.quotes : filterPageTypes.resources] = filtersMap
    let resourceList = Object.values(resources.entities)
    if (isQuotes) resourceList = getResourcesWithQuotes(resourceList, budget.budget)

    const { resourceLabels, tags } = this.filterResourceSets(resourceList)
    const { workersByEmail } = workforce

    this.addTagFilterGroup({ filters, filtersMap, filtersUIData, tags, workersByEmail, title: 'Workforce Contact', emptyTitle: 'workforce contacts added', onRight: true, sort: true })

    this.addLabelFilters({ filtersUIData, filters, resourceLabels, filtersMap, labelMaps: events.labelMaps })
    return filtersUIData
  }

  async buildExhibitorTableFilterUI(isStands = false): Promise<FiltersGroupingUI[]> { 
    const { filters: allFilters, exhibitors, programs, workforce, events } = await this.storeObject();
    const filters = allFilters[isStands ? filterPageTypes.exhibitor_stands : filterPageTypes.exhibitors]
    const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()
    const event = events.event

    // Store references to necessary information for enabling / disabling filters
    this.filtersMaps[isStands ? filterPageTypes.exhibitor_stands : filterPageTypes.exhibitors] = filtersMap
    const exhibitorList = Object.values(exhibitors.entities)

    const { exhibitorLabels, tags, programLabels, programIds } = this.filterExhibitorSetsByPrograms({ exhibitorList, programList: Object.values(programs.entities) }, events.event, isStands)
    const { workersByEmail } = workforce

    this.addTagFilterGroup({ filters, filtersMap, filtersUIData, tags, workersByEmail, title: 'Workforce Contact', emptyTitle: 'workforce contacts added', onRight: true, sort: true })
    this.addEntityTypes(filters, filtersMap, filtersUIData, getSet(exhibitorList, 'entityTypeId'), event.exhibitorTypes, 'Exhibitor Types')

    const sortedIds = sortPrograms(events.event.programOrder, Object.values(programs.entities)).map(p => p.id).filter(id => programIds.has(id))
    console.log({ programIds, sortedIds })

    this.addCheckBoxFilterGroup({ filtersUIData, filters, idList: programIds, sortedIds, fetcher: id => programs.entities[id], type: filterTypes.programs, title: PROGRAM_NAMES.btn_plural, filtersSubMap: filtersMap.programs })

    this.addLabelFilters({ filtersUIData, filters, exhibitorLabels,  programLabels, filtersMap, labelMaps: events.labelMaps })

    return filtersUIData
  }


  async buildProgramTableFilterUI(): Promise<FiltersGroupingUI[]> {
    const { filters: allFilters, performers, programs, sponsors, workforce, events } = await this.storeObject();
    const filters = allFilters.programTable
     const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()
    this.filtersMaps[filterPageTypes.programTable] = filtersMap

    const programsList = sortPrograms(events.event.programOrder, Object.values(programs.entities))
    
    const programIds = getSet(programsList, 'id')
    const sortedIds = programsList.map(p => p.id).filter(id => programIds.has(id))

    this.addCheckBoxFilterGroup({ filtersUIData, filters, sortedIds, fetcher: id => programs.entities[id], type: filterTypes.programs, title:  PROGRAM_NAMES.btn_plural, filtersSubMap: filtersMap.programs })

    const programLabels = getNestedSet(programsList, 'labels')
    this.addLabelFilters({ filtersUIData, filters, programLabels, filtersMap, labelMaps: events.labelMaps })

    return filtersUIData

  }

  async addEntityTypes(filters: FilterGroup, filtersMap: FiltersMap, filtersUIData: FiltersGroupingUI[], ids: Set<string>, types: Ranking[], title: string, addNoType = false) {
    const usedTypes = types.filter(t => ids.has(t.id))
    const typeFilters = filters.types
    const typeUIs: FilterUI[] = usedTypes.map(t => ({
      name: t.name, type: FilterUIType.PhotoLabel, id: t.id, selected: isSelected(typeFilters, t.id)
    }))
    if (addNoType) typeUIs.unshift({ name: 'No Type', type: FilterUIType.PhotoLabel, id: 'noType', selected: isSelected(typeFilters, 'noType')})

    filtersUIData.push({
      title,
      rightColumn: true,
      filterGroups: [{
        title,
        hideTitle: true,
        groupId: filterTypes.types,
        filters: typeUIs
      }]
    })
  }

  async buildPerformerOrSponsorSessionTableFilterUI(filterPageType): Promise<FiltersGroupingUI[]> { 

    const { filters: allFilters, performers, programs, sponsors, workforce, events } = await this.storeObject();
    const event = events.event
    const filters = allFilters[filterPageType]
    const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()

    // Store references to necessary information for enabling / disabling filters
    this.filtersMaps[filterPageType] = filtersMap
    const performerList = Object.values(performers.entities)
    const sponsorList = Object.values(sponsors.entities)
    const programsList = Object.values(programs.entities)

    let setFunction
    switch (filterPageType) {
      case filterPageTypes.performersTable:
        setFunction = this.filterSessionProgramSetsByPerformer
        break;
      case filterPageTypes.performerSessionsTable:
        setFunction = this.filterPerformerSetsBySessionsPrograms
        break;
      case filterPageTypes.sponsors:
        setFunction = this.filterSessionProgramSetsBySponsor
        break;
      case filterPageTypes.sponsor_sessions:
        setFunction = this.filterSponsorSetsBySessionsPrograms
        break;
      default:
        console.log(`MISSING SET FUNCTION FOR ${filterPageType}!!! Can't build filters menu`)
        return
    }

    const { performerLabels, sponsorLabels, tags, programLabels, programIds, sessionLabels } = setFunction({ performerList, sponsorList, programsList })
    // console.log({ performerLabels, sponsorLabels, tags, programLabels, programIds, sessionLabels })

    const { workersByEmail } = workforce

    if (filterPageType === filterPageTypes.performersTable || filterPageType === filterPageTypes.sponsors) this.addTagFilterGroup({ filters, filtersMap, filtersUIData, tags, workersByEmail, title: 'Workforce Contact', emptyTitle: 'workforce contacts added', onRight: true, sort: true })

    if (filterPageType === filterPageTypes.performersTable) this.addEntityTypes(filters, filtersMap, filtersUIData, getSet(performerList, 'entityTypeId'), event.performerTypes, 'Performer Types')
    if (filterPageType === filterPageTypes.sponsors) this.addEntityTypes(filters, filtersMap, filtersUIData, getSet(sponsorList, 'sponsorTypeId'), event.sponsorTypes, 'Sponsor Types', true)

    console.log({ performerTypes: event.performerTypes, sponsorTypes: event.sponsorTypes, types: filters.types, performerList, sponsorList })

    const sortedIds = sortPrograms(events.event.programOrder, programsList).map(p => p.id).filter(id => programIds.has(id))
    this.addCheckBoxFilterGroup({ filtersUIData, filters, idList: programIds, sortedIds, fetcher: id => programs.entities[id], type: filterTypes.programs, title:  PROGRAM_NAMES.btn_plural, filtersSubMap: filtersMap.programs })

    this.addLabelFilters({ filtersUIData, filters, performerLabels, sponsorLabels, sessionLabels, programLabels, filtersMap, labelMaps: events.labelMaps })

    return filtersUIData


  }

  addAccountFilters(filtersUIData: FiltersGroupingUI[], filtersMap: FiltersMap, { accountList, publicInfoList, usedAccountLabelSetsByAccountId, filters, accountLabelListsByAccountId, inactiveAccountsList }: FrontPageFilterUIParams, ingoreInactives = false): void {
    const labelGroups: FilterUI[] = []
    const accountFilterList = filters.accounts
    const fullLabelFilterList = filters.eventLabels
    accountList.forEach(({ id: accountId, title, photoURL }) => {
      const labelGroup: FilterUI = {
        type: FilterUIType.NestedLabelGroup,
        photoData: photoURL ? {photoURL} : { title },
        id: accountId,
        name: title,
        selected: isSelected(accountFilterList, accountId),
        showTitle: true,
        children: Array.from(usedAccountLabelSetsByAccountId[accountId]).map((fullLabelId: string): FilterUI => {
          const labelId = fullLabelId.split('|')[0]
          const { color, label } = <Label>accountLabelListsByAccountId[accountId].find((l: Label) => l.id === labelId)
          const labelFilter: FilterUI = {
            type: FilterUIType.ColoredLabel,
            color,
            name: label,
            id: fullLabelId,
            innerGroupId: filterTypes.eventLabels,
            selected: isSelected(fullLabelFilterList, fullLabelId)
          }
          filtersMap.eventLabels[fullLabelId] = labelFilter
          return labelFilter
        }).sort((labelFilterA, labelFilterB) => this.uiService.sortLabels(
          { color: labelFilterA.color, label: labelFilterA.name } as Label,
          { color: labelFilterB.color, label: labelFilterB.name } as Label))
      }
      filtersMap.accounts[accountId] = labelGroup
      labelGroups.push(labelGroup)
    })

    if (labelGroups.length) filtersUIData.push({
      title: 'Accounts',
      filterGroups: [{
        groupId: filterTypes.accounts,
        filters: labelGroups,
      }]
    })

    const workforceAccountLabelGroups: FilterUI[] = []
    publicInfoList.forEach(({ id, title, photoURL }) => {
      const labelGroup: FilterUI = {
        type: FilterUIType.PhotoLabel,
        name: title,
        photoData: photoURL ? { photoURL } : { title },
        showTitle: true,
        id,
        selected: isSelected(accountFilterList, id),
      }
      filtersMap.accounts[id] = labelGroup
      workforceAccountLabelGroups.push(labelGroup)
    })

    if (workforceAccountLabelGroups.length) filtersUIData.push({
      title: 'Workforce Accounts',
      filterGroups: [{
        groupId: filterTypes.accounts,
        filters: workforceAccountLabelGroups,
      }]
    })

    const inactiveAccountsGroup: FilterUI[] = []
    inactiveAccountsList.forEach(({ id, title, photoURL }) => {
      const labelGroup: FilterUI = {
        type: FilterUIType.PhotoLabel,
        name: title,
        photoData: photoURL ? { photoURL } : { title },
        showTitle: true,
        soloSelection: true,
        id,
        selected: isSelected(accountFilterList, id),
      }
      filtersMap.accounts[id] = labelGroup
      inactiveAccountsGroup.push(labelGroup)
    })
    if (inactiveAccountsList.length && !ingoreInactives) filtersUIData.push({
      title: 'Inactive Accounts',
      filterGroups: [{
        groupId: filterTypes.accounts,
        filters: inactiveAccountsGroup,
      }],
      defaultClosed: !inactiveAccountsList.some(({ id }) => isSelected(accountFilterList, id))
    })
  }  

  buildFrontPageFilterUI({ accountList, publicInfoList, you, usedAccountLabelSetsByAccountId, filters, accountLabelListsByAccountId, inactiveAccountsList }: FrontPageFilterUIParams): FiltersGroupingUI[] {

    const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()
    this.filtersMaps[filterPageTypes.home] = filtersMap
    this.addMyEvents(filtersUIData, filters, filtersMap, you)
    this.addAccountFilters(filtersUIData, filtersMap, { accountList, publicInfoList, usedAccountLabelSetsByAccountId, filters, accountLabelListsByAccountId, inactiveAccountsList })
    // console.log({ filtersUIData })

    return filtersUIData
  }

  public async buildFullOnsiteTimelineFilterUI(filterPageType): Promise<FiltersGroupingUI[]> { // "Full" means all dates, not just the single date like the old timeline displayed
    const multiTimelines: DateSchedule[] = <DateSchedule[]> await lastValueFrom(this.store.select(unfilteredFullMultiTimelineReselector).pipe(take(1))) // getOneReselectorPromise(this.store, unfilteredFullMultiTimelineReselector)
    return await this.loadOnsiteTimelineFilterUI(multiTimelines, filterPageType)
  }
  
  public async loadOnsiteTimelineFilterUI(multiTimelines: DateSchedule[], filterPageType: string): Promise<FiltersGroupingUI[]> {

    const { filters: allFilters, performers, sponsors, exhibitors, events, workforce, resources, programs: programState, attendees } = await this.storeObject();
    const programEntities = await lastValueFrom(this.store.select(programsFeature.selectEntities).pipe(take(1))) // ensure we have the latest programs entities for the sorting and mapping below
    const programEntitesTheOtherWay = programsStateSelector(this.store);
    console.log({programEntities, programEntitesTheOtherWay})
    const programsMap = programState.entities || {}

    // console.log("loadOnsiteTimelineFilterUI: ", { multiTimeline, selectedDateIndex: onsite.selectedDateIndex })
    const { programLabels, sessionLabels, activityLabels, tags, performerIds, sponsorIds, exhibitorIds, programs, resourceIds, attendeeIds } = getOnsiteTimelineSets(multiTimelines, exhibitors.entities, events.event.exhibitorStands)

    const event = events.event
    // console.log(programs.map(p => p.title), programs)
    
    // console.log({ programLabels, sessionLabels, activityLabels, groupTags, tags, performerIds, sponsorIds, programs: jsonCopyObject(programs) })

    const filters = allFilters[filterPageType]
    const filtersMap = makeFiltersMap()

    const programsById = makeMapFromListOfObjectsAndKey(programs, 'scheduleId')
    const getProgramTitleById = (id) => programsById[id]['title']
    const getTimelineProgramById = (id) => programsById[id]

    const schedulesTitleById = makeMapFromListOfObjectsAndKey(flatten(programs.map(p => p.sessions)).map(SOA => SOA.type === 'activity' ? SOA : null).filter(SOA => SOA), 'linkId')
    const getScheduleTitleById = (id) => schedulesTitleById[id]['schedule_title']

    const filtersUIData: FiltersGroupingUI[] = []
    
    this.filtersMaps[filterPageType] = filtersMap

    const allStandalones = new Set<string>(programs.filter(p => p.type === 'schedule').map(p => p.scheduleId))
    const standAlonePrograms = Array.from(allStandalones).map(id => programs.find(p => p.type === 'schedule' && p.scheduleId === id))
    standAlonePrograms.sort(sortByProp('title'))
    const sortedStandaloneIds = standAlonePrograms.map(p => p.scheduleId)

    const programsAndSchedules = programs.map(p => {
      const sIds = []
      const activities = p.sessions.filter(s => s.type === 'activity') as OnsiteActivity[]
      activities.sort((a, b) => a.scheduleOrder - b.scheduleOrder)
      activities.forEach(a => !sIds.includes(a.linkId) && sIds.push(a.linkId))
      return { pId: p.scheduleId, sIds }
    })

    const programsAndSchedulesOneDeepList: OneDeepCheckbox[] = []
    programsAndSchedules.filter(({ pId, sIds }) => !(sIds.length === 1 && pId === sIds[0])).forEach(({ pId, sIds }) => {
      if (allStandalones.has(pId)) return
      let pIndex = programsAndSchedulesOneDeepList.findIndex(p => p.pId === pId)
      if (pIndex < 0) {
        pIndex = programsAndSchedulesOneDeepList.length
        programsAndSchedulesOneDeepList.push({ pId, sIds: [], type: 'schedules', order: programsMap[pId]?.order || 0 })
      }
      const programAndSchedules = programsAndSchedulesOneDeepList[pIndex]
      sIds.forEach(sId => !programAndSchedules.sIds.includes(sId) && programAndSchedules.sIds.push(sId))
    })

    const sortedProgramsAndSchedulesOneDeepList = sortPidOrderArray(event.programOrder, programsAndSchedulesOneDeepList)

    this.addTagFilterGroups({ filters, filtersMap, filtersUIData, tags, workersByEmail: workforce.workersByEmail, onRight: true, performerIds, performerEntities: performers.entities, sponsorIds, sponsorEntities: sponsors.entities, exhibitorIds, exhibitorEntities: exhibitors.entities, resourceIds, resourceEntities: resources.entities, attendeeIds, attendeeEntities: attendees.entities })

    this.addOneDeepCheckBoxFilterGroup({ filtersUIData, filters, oneDeepList: sortedProgramsAndSchedulesOneDeepList, fetcher: getProgramTitleById, oneDeepFetcher: getScheduleTitleById, type: filterTypes.programs, oneDeepType: filterTypes.schedules, title:  PROGRAM_NAMES.btn+'s & Program Schedules', filtersSubMap: filtersMap.programs, oneDeepFiltersSubMap: filtersMap.schedules })

    this.addCheckBoxFilterGroup({ filtersUIData, filters, idList: allStandalones, sortedIds: sortedStandaloneIds, fetcher: getTimelineProgramById, type: filterTypes.programs, title: 'Standalone Schedules', filtersSubMap: filtersMap.programs }, true)

    this.addLabelFilters({ filtersUIData, filters, programLabels, sessionLabels, activityLabels, filtersMap, labelMaps: events.labelMaps })
    this.disableEnableFilters(filterPageType, filters)

    return filtersUIData
    
  }
  public async buildProgramLogisticsFilterUI(): Promise<FiltersGroupingUI[]> {
    const { programs: programsState, filters: allFilters, events, workforce, performers, sponsors } = await this.storeObject();

    const unsortedPrograms = Object.values(programsState.entities)
    const programs = sortPrograms(events.event.programOrder, unsortedPrograms)

    const filters = allFilters.programLogistics
    const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()
    this.filtersMaps[filterPageTypes.programLogistics] = filtersMap
    // console.log(this.filtersMaps)

    const { sessionLabels, programLabels, programIds, performerIds, sponsorIds } = this.getProgramTimelineSets(programs, Object.values(performers.entities), Object.values(sponsors.entities))
    const programMap = makeMapFromListOfObjectsAndKey<Program>(programs, 'id')
    const programTitleFetcher = id => programMap[id].title

    this.addTagFilterGroups({ filters, filtersMap, filtersUIData, workersByEmail: workforce.workersByEmail, onRight: true, performerIds, performerEntities: performers.entities, sponsorIds, sponsorEntities: sponsors.entities })

    const programDaysOneDeepList = getProgramDaysOneDeepList(programs)

    const programEntities = makeMapFromListOfObjectsAndKey(programs, 'id')
    const getProgramDayOrDateById = getProgramDayOrDateByFilterIdConstructor(programEntities)

    this.addOneDeepCheckBoxFilterGroup({ filtersUIData, filters, oneDeepList: programDaysOneDeepList, fetcher: programTitleFetcher, oneDeepFetcher: getProgramDayOrDateById, type: filterTypes.programs, oneDeepType: filterTypes.days, title:  PROGRAM_NAMES.btn_plural, filtersSubMap: filtersMap.programs, oneDeepFiltersSubMap: filtersMap.days })

    this.addLabelFilters({ filtersUIData, filters, programLabels, sessionLabels, filtersMap, labelMaps: events.labelMaps })

    this.disableEnableFilters(filterPageTypes.programLogistics, filters)
    return filtersUIData

  }
  public async buildTimelineViewFilterUI(filterType: keyof FilterGroupTypes = 'publish'): Promise<FiltersGroupingUI[]> {
    const { filters: allFilters, events, workforce, performers, sponsors, programs } = await this.storeObject();
    
    const filters = allFilters[filterType]
    const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()
    this.filtersMaps[filterPageTypes.publish] = filtersMap

    const unsortedPrograms = Object.values(programs.entities)
    const programsList = sortPrograms(events.event.programOrder, unsortedPrograms)

    // console.log({ programsList: jsonCopyObject(programsList )})
    const programMap = makeMapFromListOfObjectsAndKey<Program>(programsList, 'id')
    const programTitleFetcher = id => programMap[id].title
    
    const { sessionLabels, programLabels, performerIds, programIds, sponsorIds } = this.getProgramTimelineSets(programsList, Object.values(performers.entities), Object.values(sponsors.entities), false)
    // console.log({ sessionLabels, programLabels, performerIds, programIds, tags, groupTags })
    this.addTagFilterGroups({ filters, filtersMap, filtersUIData, workersByEmail: workforce.workersByEmail, onRight: true, performerIds, performerEntities: performers.entities, sponsorIds, sponsorEntities: sponsors.entities })


    const programDaysOneDeepList = getProgramDaysOneDeepList(programsList)
    const getProgramDayOrDateById = getProgramDayOrDateByFilterIdConstructor(programs.entities)

    this.addOneDeepCheckBoxFilterGroup({ filtersUIData, filters, oneDeepList: programDaysOneDeepList, fetcher: programTitleFetcher, oneDeepFetcher: getProgramDayOrDateById, type: filterTypes.programs, oneDeepType: filterTypes.days, title: PROGRAM_NAMES.btn_plural, filtersSubMap: filtersMap.programs, oneDeepFiltersSubMap: filtersMap.days })
    // console.log({ filtersUIData, filters, programLabels, sessionLabels, filtersMap })
    this.addLabelFilters({ filtersUIData, filters, programLabels, sessionLabels, filtersMap, labelMaps: events.labelMaps })
    
    // console.log({ filtersUIData })
    this.disableEnableFilters(filterType, filters)
    return filtersUIData
  }
  public async buildProgramTimelineFilterUI(programs: Program[], snapshotFetchers = null, snapshotPrograms: any[] = null): Promise<FiltersGroupingUI[]> {
    if (snapshotPrograms) {
      this.snapshotPrograms = snapshotPrograms
    }
    const { filters: allFilters, events, workforce, performers, sponsors } = await this.storeObject();
    const filters = snapshotFetchers ? allFilters.programTimelineSnapshot : allFilters.programTimeline
     const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap()
    this.filtersMaps[snapshotFetchers ? filterPageTypes.programTimelineSnapshot : filterPageTypes.programTimeline] = filtersMap

    if (snapshotFetchers) {
      console.log({ programs, snapshotPrograms, snapshotFetchers, fetchedPrograms: snapshotPrograms.map(p => snapshotFetchers.programFetcher(p.pID)) })
      const { programLabelFetcher, sessionLabelFetcher, programFetcher, workersByEmail, performers } = snapshotFetchers // TODO: ADD workersByEmail to the snapshotFetchers that are saved with the snapshot
      // console.log({ snapshotPrograms })
      const { sessionLabels, programLabels, programIds, performerIds } = this.getProgramTimelineSnapshotSets( snapshotPrograms )
      this.addTagFilterGroups({ filters, filtersMap, filtersUIData, workersByEmail: workersByEmail, onRight: true, performerIds, performerEntities: performers })

      const sortedIds = sortPrograms(events.event.programOrder, programs).map(p => p.id).filter(id => programIds.has(id))
      this.addCheckBoxFilterGroup({ filtersUIData, filters, idList: programIds, sortedIds, fetcher: programFetcher, type: filterTypes.programs, title:  PROGRAM_NAMES.btn_plural, filtersSubMap: filtersMap.programs })
      this.addLabelFilters({ filtersUIData, filters, programLabels, sessionLabels, filtersMap, programLabelFetcher, sessionLabelFetcher, labelMaps: events.labelMaps })
    } else {
      const programMap = makeMapFromListOfObjectsAndKey<Program>(programs, 'id')
      const programTitleFetcher = (id: string) => programMap[id].title
      
      const { sessionLabels, programLabels, performerIds, programIds, sponsorIds } = this.getProgramTimelineSets(programs, Object.values(performers.entities), Object.values(sponsors.entities))
      this.addTagFilterGroups({ filters, filtersMap, filtersUIData, workersByEmail: workforce.workersByEmail, onRight: true, performerIds, performerEntities: performers.entities, sponsorIds, sponsorEntities: sponsors.entities })

      const programDaysOneDeepList = getProgramDaysOneDeepList(programs.filter(p => !!p.date))
      const programEntities = makeMapFromListOfObjectsAndKey(programs, 'id')
      const getProgramDayOrDateById = getProgramDayOrDateByFilterIdConstructor(programEntities)

      this.addOneDeepCheckBoxFilterGroup({ filtersUIData, filters, oneDeepList: programDaysOneDeepList, fetcher: programTitleFetcher, oneDeepFetcher: getProgramDayOrDateById, type: filterTypes.programs, oneDeepType: filterTypes.days, title:  PROGRAM_NAMES.btn_plural, filtersSubMap: filtersMap.programs, oneDeepFiltersSubMap: filtersMap.days })

      this.addLabelFilters({ filtersUIData, filters, programLabels, sessionLabels, filtersMap, labelMaps: events.labelMaps })
    }

    // console.log({ filtersUIData })
    this.disableEnableFilters(snapshotFetchers ? filterPageTypes.programTimelineSnapshot : filterPageTypes.programTimeline, filters)
     return filtersUIData
  }

  private getAssetSets(assets: Asset[], programs: Program[], user: User) {
    const responsibilityEmails = getSet(assets, 'responsibility')
    responsibilityEmails.delete(user.email)
    const createdByUIDs = getSet(assets, 'createdBy')
    createdByUIDs.delete(user.uid)

    const assetLabels = getNestedSet(assets, 'labels')
    const assetTypes = getSet(assets, 'icon')
    const assetCategories = getSet(assets, 'entityTypeId')

    const assetIds = assets.map(a => a.id)
    const programIds = getSet(programs.filter(p => p.assetIds && assetIds.some(id => p.assetIds.includes(id))), 'id')
    const entityIds = getSet(assets, 'associatedId')

    return { responsibilityEmails, createdByUIDs, assetLabels, programIds, entityIds, assetTypes, assetCategories }
  }

  private addAssociatedGroups(filtersUIData: FiltersGroupingUI[], entityIds: Set<string>, filters: FilterGroup, performers: Dictionary<Performer>, sponsors: Dictionary<Sponsor>, exhibitors: Dictionary<Exhibitor>, assets: Dictionary<Asset>, resources: Dictionary<JoiResource>) {
    
    const associatedWith = Array.from(entityIds)
    const associatedGroups: FiltersGroupUI[] = [
      {
        title: 'Performers',
        groupId: filterTypes.entityIds,
        filters: associatedWith.map(a => performers[a]).filter(p => p).map(p => ({ name: p.name, type: FilterUIType.PhotoLabel, photoData: {
          title: p.name, photoURL: p.photoUrl
        }, id: p.id, selected: isSelected(filters.entityIds, p.id) })).sort(sortByProp('name'))
      },
      {
        title: 'Sponsors',
        groupId: filterTypes.entityIds,
        filters: associatedWith.map(a => sponsors[a]).filter(s => s).map(s => ({ name: s.name, type: FilterUIType.PhotoLabel, photoData: { title: s.name }, id: s.id, selected: isSelected(filters.entityIds, s.id) })).sort(sortByProp('name'))
      },
      {
        title: 'Exhibitors',
        groupId: filterTypes.entityIds,
        filters: associatedWith.map(a => exhibitors[a]).filter(e => e).map(e => ({ name: e.name, type: FilterUIType.PhotoLabel, photoData: { title: e.name }, id: e.id, selected: isSelected(filters.entityIds, e.id) })).sort(sortByProp('name'))
      },
      {
        title: 'Assets',
        groupId: filterTypes.entityIds,
        filters: associatedWith.map(a => assets[a]).filter(e => e).map(e => ({ name: e.name, type: FilterUIType.Asset, asset: e, id: e.id, selected: isSelected(filters.entityIds, e.id) })).sort(sortByProp('name'))
      },
      {
        title: 'Resources',
        groupId: filterTypes.entityIds,
        filters: associatedWith.map(a => resources[a]).filter(r => r).map(r => ({ name: r.name, type: FilterUIType.PhotoLabel, photoData: { title: r.name }, id: r.id, selected: isSelected(filters.entityIds, r.id) })).sort(sortByProp('name'))
      }
    ].filter(group => !!group.filters.length)
    // console.log({ associatedWith, entityIds, associatedGroups })

    filtersUIData.push({
      title: 'Associated with',
      emptyMessage: !associatedGroups.length ? 'No tasks associated' : null,
      filterGroups: associatedGroups
    })
  }

  public async buildAssetTableFilterUI(filterPageType = filterPageTypes.asset_table): Promise<FiltersGroupingUI[]> {
    try {
      const { filters: allFilters, user, programs, workforce, events, performers, sponsors, exhibitors, assets, resources } = await this.storeObject();
    
      const event = events.event
      const filters = allFilters.asset_table
      const you = user.user
       const filtersUIData: FiltersGroupingUI[] = []
      const filtersMap = makeFiltersMap() // a map that holds memory references to each possible filter.  Have decided to make filtersUIData a mutable data structure as otherwise this would be a lot more complicated / expensive to do
  
      // Store references to necessary information for enabling / disabling filters
      this.filtersMaps[filterPageType] = filtersMap
      const assetList = Object.values(assets.entities)
      
      const { responsibilityEmails, assetLabels, entityIds, assetTypes, assetCategories } = this.getAssetSets(assetList, Object.values(programs), you)
      // console.log( { tasks, responsibilityEmails, visibleToEmails, createdByUIDs, taskLabels, programIds, groupVisibilityNames})
  
      this.addMetaFilters(filtersUIData, filters, filtersMap, you, true)
  
      const { workersByEmail, workersByUId } = workforce
  
      filtersUIData.push({
        title: 'Labels',
        filterGroups: [{
          title: 'Asset Labels',
          hideTitle: true,
          groupId: filterTypes.assetLabels,
          filters: this.addLabelFilterGroup({
            filterList: filters.assetLabels,
            labelFetcher: (id) => events.labelMaps.asset_labels[id],
            possibleLabels: assetLabels,
            filtersSubMap: filtersMap[filterTypes.assetLabels]
          })
        }]
      })

      filtersUIData.push({
        title: 'Asset Types',
        filterGroups: [{
          title: 'Asset Types',
          hideTitle: true,
          groupId: filterTypes.types,
          filters: Array.from(assetTypes).sort().map((t: string) => ({
            id: t,
            name: assetIconToName[t],
            type: 'Icon',
            selected: isSelected(filters.types, t),
            matIconName: assetIconIds[t]
          }))
        }]
      })

      const categories: Ranking[] = Array.from(assetCategories).map(c => event.assetCategories.find(r => r.id === c)).filter(c => !!c)
      console.log({ assetCategories, categories, catMap: event.assetCategories })

      filtersUIData.push({
        title: 'Asset Categories',
        filterGroups: [{
          title: 'Asset Categories',
          hideTitle: true,
          groupId: filterTypes.categories,
          filters: categories.map(c => ({
            id: c.id,
            name: c.name,
            type: 'Checkbox',
            selected: isSelected(filters.categories, c.id)
          }))
        }]
      })
  
      filtersUIData.push({
        title: 'Responsibility',
        filterGroups: [{
          title: 'Responsibility',
          hideTitle: true,
          groupId: filterTypes.responsibilities,
          filters: this.getPeopleFilterGroup({
            idType: 'email',
            filterList: filters.responsibilities,
            userMap: workersByEmail,
            possibleList: responsibilityEmails,
            yourLabel: assetList.filter((t: any) => t.responsibility === you.email).length === 0 ? null : 'Me', // this is a little hacky, but if yourLabel doesn't exist then the you filter for this group will not be created, hence the checks
            filtersSubMap: filtersMap[filterTypes.responsibilities],
            you
          }, true)
        }]
      })
  
      this.addAssociatedGroups(filtersUIData, entityIds, filters, performers.entities, sponsors.entities, exhibitors.entities, assets.entities, resources.entities)
  
      this.filtersMaps[filterPageType] = filtersMap
      this.disableEnableFilters(filterPageType, allFilters[filterPageType])
  
       return filtersUIData
    } catch (error) {
      console.log(error)
      return null
    }
    
  }

  
  public async buildTaskPageFilterUI(filterPageType: keyof FilterGroupTypes, allTasks = false): Promise<FiltersGroupingUI[]> {
    const { filters: allFilters, tasks: tasksObject, user, programs, workforce, events, performers, sponsors, exhibitors, assets, resources } = await this.storeObject();
    
    let tasks = Object.values(tasksObject.entities)
    const filters = allFilters[filterPageType]
    const you = user.user
    if (filterPageType === filterPageTypes.taskTime) {
      tasks = filterTimeTasks(tasks, you)
    }

    const filtersUIData: FiltersGroupingUI[] = []
    const filtersMap = makeFiltersMap() // a map that holds memory references to each possible filter.  Have decided to make filtersUIData a mutable data structure as otherwise this would be a lot more complicated / expensive to do

    // Store references to necessary information for enabling / disabling filters
    this.filtersMaps[filterPageType] = filtersMap
    
    const { responsibilityEmails, visibleToEmails, createdByUIDs, taskLabels, programIds, groupVisibilityNames, entityIds } = this.getTaskSets(tasks, you)
    // console.log( { tasks, responsibilityEmails, visibleToEmails, createdByUIDs, taskLabels, programIds, groupVisibilityNames})

    this.addMetaFilters(filtersUIData, filters, filtersMap, you)
    if (['allTasksCalendar', 'allTasks'].includes(filterPageType)) {
      const frontPageData = await lastValueFrom(this.store.select(frontPageFilterUIDataReselector).pipe(take(1)))
      if (frontPageData) {
        const { accountList, publicInfoList, usedAccountLabelSetsByAccountId, accountLabelListsByAccountId, inactiveAccountsList, you } = frontPageData
        const accountListData: FrontPageFilterUIParams = { accountList, publicInfoList, usedAccountLabelSetsByAccountId, filters, accountLabelListsByAccountId, inactiveAccountsList, you }
        this.addAccountFilters(filtersUIData, filtersMap, accountListData, true)
      }
    } 
    const { workersByEmail, workersByUId } = allTasks ? getWorkersByEmailAndUidFromMultipleEvents(events.entities) : workforce
    
    if (!allTasks) {
 
      filtersUIData.push({
        title: 'Labels',
        filterGroups: [{
          title: 'Task Labels',
          hideTitle: true,
          groupId: filterTypes.taskLabels,
          filters: this.addLabelFilterGroup({
            filterList: filters.taskLabels,
            labelFetcher: (id) => events.labelMaps.task_labels[id],
            possibleLabels: taskLabels,
            filtersSubMap: filtersMap[filterTypes.taskLabels]
          })
        }]
      })
    }

    filtersUIData.push({
      title: 'Responsibility',
      filterGroups: [{
        title: 'Responsibility',
        hideTitle: true,
        groupId: filterTypes.responsibilities,
        filters: this.getPeopleFilterGroup({
          idType: 'email',
          filterList: filters.responsibilities,
          userMap: workersByEmail,
          possibleList: responsibilityEmails,
          yourLabel: tasks.filter(t => t.responsibility === you.email).length === 0 ? null : 'Me', // this is a little hacky, but if yourLabel doesn't exist then the you filter for this group will not be created, hence the checks
          filtersSubMap: filtersMap[filterTypes.responsibilities],
          you
        }, true)
      }]
    })
    
    if (!allTasks) {
      const programFetcher = id => <Program>programs.entities[id]
      
      const sortedIds = sortPrograms(events.event.programOrder, Object.values(programs.entities)).map(p => p.id).filter(id => programIds.has(id))
      this.addCheckBoxFilterGroup({ filtersUIData, filters, idList: programIds, sortedIds, fetcher: programFetcher, type: filterTypes.programs, title: PROGRAM_NAMES.btn_plural, filtersSubMap: filtersMap.programs })

      filtersUIData.push({
        title: 'Visible to me and...',
        filterGroups: [{
          title: 'Visible to me and...',
          hideTitle: true,
          groupId: filterTypes.visibilities,
          filters: this.getPeopleFilterGroup({
            idType: 'email',
            filterList: filters.visibilities,
            userMap: workersByEmail,
            possibleList: visibleToEmails,
            filtersSubMap: filtersMap[filterTypes.visibilities],
            you
          }, true)
        }]
      })
      this.addAssociatedGroups(filtersUIData, entityIds, filters, performers.entities, sponsors.entities, exhibitors.entities, assets.entities, resources.entities)
    }

    filtersUIData.push({
      title: 'Created by',
      filterGroups: [{
        title: 'Created by',
        hideTitle: true,
        groupId: filterTypes.createdBy,
        filters: this.getPeopleFilterGroup({
          idType: 'uid',
          filterList: filters.createdBy,
          userMap: workersByUId,
          possibleList: createdByUIDs,
          yourLabel: tasks.filter(t => t.createdBy === you.uid).length === 0 ? null : 'Me',
          filtersSubMap: filtersMap[filterTypes.createdBy],
          you
        }, true)
      }]
    })

    this.filtersMaps[filterPageType] = filtersMap
    this.disableEnableFilters(filterPageType, allFilters[filterPageType])

    // console.log({filtersMap, filtersUIData})
   return filtersUIData
  }
}
